/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileNwc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zM7 19.478V4.5l2.442 1.749 3.892 2.787 3.598-4.283.068.023v14.718c-.096 0-.191.002-.286.003-.25.004-.497.008-.742-.015-.1-.009-.212-.142-.274-.242-.605-.981-1.206-1.965-1.807-2.949l-.793-1.297a4.608 4.608 0 0 0-.132-.2l-.087-.126L7 19.478z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileNwc as FillFileNwc };
